"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'shortcuts.find.title': 'Przełącz Wyszukiwanie Web',
    'shortcuts.find.description': 'Włącza lub wyłącza funkcjonalność wyszukiwania internetowego',
};
